module.exports = __webpack_public_path__ + "static/media/classics-10217_02.4179fddd.png";